import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="text-center bg-slate-900 text-slate-500 py-2">
      <div className="border-slate-700 border-t py-2 max-w-screen-xl mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm font-mono pb-2">
          <a href="https://github.com/AnandKri" target="_blank" rel="noopener noreferrer" className="hover:text-teal-300">GitHub</a>
          <a href="https://www.linkedin.com/in/anand-krishna99/" target="_blank" rel="noopener noreferrer" className="hover:text-teal-300">LinkedIn</a>
          <a href="https://www.instagram.com/frame.of.moment" target="_blank" rel="noopener noreferrer" className="hover:text-teal-300">Instagram</a>
          <a href="mailto:anand.krishna0802@gmail.com" className="hover:text-teal-300">Email</a>
        </div>
        <div className="text-sm font-mono">Developed by Anand Krishna © {new Date().getFullYear()}</div>
        <div className="text-sm font-mono">Design inspired by <Link to="https://v4.brittanychiang.com/" target="_blank" className="hover:text-teal-300">brittanychiang.com</Link></div>
      </div>
    </footer>
  );
};

export default Footer;